/**
 * WordPress dependencies
 */
import { layout } from '@wordpress/icons';
/**
 * Internal dependencies
 */

const metadata = {
  $schema: "https://schemas.wp.org/trunk/block.json",
  apiVersion: 2,
  name: "core/post-template",
  title: "Post Template",
  category: "theme",
  parent: ["core/query"],
  description: "Contains the block elements used to render a post, like the title, date, featured image, content or excerpt, and more.",
  textdomain: "default",
  usesContext: ["queryId", "query", "queryContext", "displayLayout", "templateSlug"],
  supports: {
    reusable: false,
    html: false,
    align: true,
    __experimentalLayout: {
      allowEditing: false
    }
  },
  style: "wp-block-post-template",
  editorStyle: "wp-block-post-template-editor"
};
import edit from './edit';
import save from './save';
const {
  name
} = metadata;
export { metadata, name };
export const settings = {
  icon: layout,
  edit,
  save
};
//# sourceMappingURL=index.js.map